import { FOOD_RISK_CATEGORIES } from "@shared/legal";

const RISK_LABELS: Record<string, string> = {
  meat: "meat",
  dairy: "dairy",
  eggs: "eggs",
  prepared: "prepared foods",
};

// Human phrase naming the higher-risk categories present in a cart, or null if
// none are. Both the in-app and express checkouts derive their prompt from this
// one function, so the triggering categories and the on-screen copy below stay
// in a single place. The server enforces the same rule via cartNeedsFoodRiskAck.
export function foodRiskLabel(categories: (string | null | undefined)[]): string | null {
  const present: string[] = [];
  for (const c of categories) {
    const cat = String(c ?? "");
    if (FOOD_RISK_CATEGORIES.includes(cat)) {
      const label = RISK_LABELS[cat] ?? "food";
      if (!present.includes(label)) present.push(label);
    }
  }
  if (present.length === 0) return null;
  if (present.length === 1) return present[0];
  return `${present.slice(0, -1).join(", ")} and ${present[present.length - 1]}`;
}

export function FoodRiskAck({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-lg border bg-muted/40 p-4 text-sm">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0"
      />
      <span className="text-muted-foreground">
        This order includes fresh {label}. Stoop doesn&rsquo;t inspect, test, or guarantee food, so I
        understand I&rsquo;m buying at my own risk directly from the maker, who is responsible for its
        safety.{" "}
        <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" className="underline">
          Learn more
        </a>
        .
      </span>
    </label>
  );
}
